import { render, staticRenderFns } from "./ExhibitionWorkDetail.vue?vue&type=template&id=e021c14c&"
import script from "./ExhibitionWorkDetail.vue?vue&type=script&lang=js&"
export * from "./ExhibitionWorkDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionWorkDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports